"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Tooltip } from "@xefi/x-react/tooltip";
const TOOLTIP_MIN_LENGTH = 16;
type Props = {
  value: string;
  children: ReactNode;
};
export const CellTooltip = t0 => {
  const $ = _c(6);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value === "-" || value.trim().length < TOOLTIP_MIN_LENGTH;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1 || $[4] !== value) {
    t2 = <Tooltip trigger={children} content={value} isDisabled={t1} placement="top" delay={300} className="max-w-sm whitespace-normal break-words text-xs" />;
    $[2] = children;
    $[3] = t1;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};